export const celliant = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 15,

  inputHeight: 25,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 10,
  inputFontFamily: '"Open Sans", sans-serif',
  inputColor: "#ffffff",
  inputBackgroundColor: "transparent",
  inputFontWeight: 400,

  inputBorderColor: "#5C8898",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#ffffff",
  inputHoverBorderColor: "#5C8898",
  inputHoverBackgroundColor: "transparent",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 15,

  selectHeight: 25,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 10,
  selectFontFamily: '"Open Sans", sans-serif',
  selectColor: "#ffffff",
  selectBackgroundColor: "transparent",
  selectFontWeight: 400,

  selectBorderColor: "#5C8898",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#ffffff",
  selectHoverBorderColor: "#5C8898",
  selectHoverBackgroundColor: "transparent",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 15,

  textAreaHeight: 25,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 10,
  textAreaFontFamily: '"Open Sans", sans-serif',
  textAreaColor: "#ffffff",
  textAreaBackgroundColor: "transparent",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#5C8898",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#ffffff",
  textAreaHoverBorderColor: "#5C8898",
  textAreaHoverBackgroundColor: "transparent",

  // **********************************
  //  placeholder
  placeholderColor: "#ffffff",
  placeholderFontFamily: '"Open Sans", sans-serif',
  placeholderFontSize: 10,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#ffffff",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 9,
  fieldLabelColor: "#ffffff",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#ffffff",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Open Sans", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#ffffff",
  descriptionFontSize: 8,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Open Sans", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 13,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#5C8898",
  checkboxUncheckedBackgroundColor: "transparent",
  checkboxCheckedBackgroundColor: "#2DA72D",
  checkboxCheckedBorderColor: "#2DA72D",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Open Sans", sans-serif',
  checkboxLabelFontSize: 9,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#ffffff",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 13,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#5C8898",
  radioUncheckedBackgroundColor: "transparent",
  radioCheckedBackgroundColor: "#2DA72D",
  radioCheckedBorderColor: "#2DA72D",

  radioAlignment: "none",

  radioLabelFontFamily: '"Open Sans", sans-serif',
  radioLabelFontSize: 9,
  radioLabelFontWeight: 400,
  radioLabelColor: "#ffffff",

  // **********************************
  // submit button

  submitMarginTop: 29,
  submitFontSize: 14,
  submitFontFamily: "'Open Sans', sans-serif",
  submitWidth: 100,
  submitWidthUnits: "%",
  submitHeight: 46,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#2DA72D",
  submitColor: "#ffffff",
  submitBorderColor: "#2DA72D",
  submitBackgroundHover: "#2DA72D",
  submitBorderColorHover: "#2DA72D",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 400,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  